import React from "react";
import { Form, Input, Select, InputNumber, Switch } from "antd";
import { IconStar } from "@tabler/icons-react";

export default function BasicSection({ issuerOptions, categoryOptions }) {
  return (
    <>
      <Form.Item
        name="issuerId"
        label="Байгууллага"
        rules={[{ required: true, message: "Байгууллага сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Банк сонгох"
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={issuerOptions}
        />
      </Form.Item>

      <Form.Item
        name="name"
        label="Зээлийн нэр"
        rules={[{ required: true, message: "Нэр оруулна уу" }]}
      >
        <Input placeholder="Жишээ: Орон сууцны зээл 6%" />
      </Form.Item>

      <Form.Item
        label="Тайлбар нэршил"
        name="highlight"
        rules={[{ required: true, message: "Тайлбар нэршил өгнө үү" }]}
      >
        <Input placeholder="2–3 үг (жишээ: Хамгийн түргэмэл)" />
      </Form.Item>

      <Form.Item
        name="categoryId"
        label="Орон сууцны зээлийн төрөл"
        rules={[{ required: true, message: "Ангилал сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Ипотек / Орон сууц / Хашаа & байшин / Түрээс"
          options={categoryOptions}
        />
      </Form.Item>

      <Form.Item
        label="Үнэлгээ (rating)"
        name="rating"
        rules={[{ required: true, message: "Үнэлгээ өгнө үү" }]}
      >
        <InputNumber
          prefix={<IconStar size={16} color="#e68200ff" />}
          min={0}
          max={5}
          step={0.1}
          placeholder="4.5"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item name="applyUrl" label="Дэлгэрэнгүй / Захиалах холбоос">
        <Input placeholder="https://..." />
      </Form.Item>

      <Form.Item
        name="featured"
        label="Нүүрэнд онцлох"
        valuePropName="checked"
        tooltip="Нүүр хуудасны 'Жишээ бүтээгдэхүүн' хэсэгт харагдана"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
